import Components from "../components";

// This adds functionality to our Fault index list to allow toggling selections
// for actions.
class ActionableFaultList extends Components.Base {
  initialize() {
    this.$target = $('.c-actions-dropdown');
    this.$allCheckboxes = this.$el.find('.action-select');
    this.$allToggleInput = this.$el.find('.batch-action-all-toggle input');
    this.hasSelection = false;
  }

  bind() {
    this.on('change', '.batch-action-all-toggle input', () => {
      if (this.hasSelection) {
        this.unCheckAll();
      } else {
        this.checkAll();
      }
    });

    this.on('change', '.action-select', evt => {
      this.$target.trigger('faultToggled', {
        faultId: evt.target.dataset.faultId,
      });

      this.updateAllToggle();
    });
  }

  unCheckAll() {
    this.$allToggleInput.prop('checked', false);
    this.$allCheckboxes.prop('checked', false);
    this.$target.trigger('clearFaults');
    this.hasSelection = false;
  }

  checkAll() {
    this.$allToggleInput.prop('checked', true);
    this.$allCheckboxes.prop('checked', true);
    this.$target.trigger('addFaults', {
      faultIds: this.$allCheckboxes.map((_, c) => c.dataset.faultId).toArray(),
    });
    this.hasSelection = true;
  }

  updateAllToggle() {
    const checkedLen = this.$allCheckboxes.filter(':checked').length;
    if (checkedLen === this.$allCheckboxes.length) {
      this.$allToggleInput[0].checked = true;
      this.hasSelection = true;
    } else if (checkedLen > 0) {
      this.$allToggleInput[0].indeterminate = true;
      this.hasSelection = true;
    } else {
      this.$allToggleInput[0].indeterminate = false;
      this.$allToggleInput[0].checked = false;
      this.hasSelection = false;
    }
  }
}

Components.collection.register({
  selector: '.c-actionable-fault-list',
  klass: ActionableFaultList,
});
